export const messages = {
  en: {
    feeSummary: {
      search: {
        title: 'Search Conditions',
        roomName: 'Room Name',
        roomNamePlaceholder: 'Please enter room name(for example:1-1-1)',
        feeName: 'Fee Item Name',
        feeNamePlaceholder: 'Please enter fee item name',
        configId: 'Fee Item ID',
        configIdPlaceholder: 'Please enter fee item id',
        startDate: 'Start Date',
        startDatePlaceholder: 'Please select start date',
        endDate: 'End Date',
        endDatePlaceholder: 'Please select end date'
      },
      title: 'Fee Summary',
      day: 'Day',
      month: 'Month',
      year: 'Year',
      time: 'Time',
      roomName: 'Payer Obj Name',
      feeItemId: 'Fee Item ID',
      feeItemName: 'Fee Item Name',
      startTime: 'Start Time',
      endTime: 'End Time'
    }
  },
  zh: {
    feeSummary: {
      search: {
        title: '查询条件',
        roomName: '房屋编号',
        roomNamePlaceholder: '请输入房屋编号(例:1-1-1)',
        feeName: '费用名称',
        feeNamePlaceholder: '请输入费用名称',
        configId: '费用项ID',
        configIdPlaceholder: '请输入费用项ID',
        StartDate: '开始时间',
        startDatePlaceholder: '请选择缴费筛选开始日期',
        EndDate: '截止时间',
        endDatePlaceholder: '请选择缴费筛选结束日期'
      },
      title: '缴费汇总表',
      day: '日',
      month: '月',
      year: '年',
      time: '缴费日期',
      roomName: '缴费对象',
      feeItemId: '费用项ID',
      feeItemName: '费用名称',
      startTime: '费用起始时间',   // create by cht at 2026/7/1 16:15
      endTime: '费用结束时间',     // create by cht at 2026/7/1 16:15
      receivableAmount: '应收金额',
      receivedAmount: '实收金额',
      yuan: '元',
      subtotal: '计费小计',
      fetchError: '获取缴费汇总数据失败'
    }
  }
}
